import { render, staticRenderFns } from "./patient_picture.vue?vue&type=template&id=359893e4&scoped=true&"
import script from "./patient_picture.vue?vue&type=script&lang=js&"
export * from "./patient_picture.vue?vue&type=script&lang=js&"
import style0 from "./patient_picture.vue?vue&type=style&index=0&id=359893e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359893e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
